module.exports = __webpack_public_path__ + "img/tt.8b05f8ef.svg";